import Link from 'next/link';
import { IBreadcrumbStep } from '@typescript/index';
import styles from '@components/Breadcrumbs/Breadcrumbs.style';
type DropdownProps = {
  activeDropdown: IBreadcrumbStep | null;
  leftPosition: number;
  onMouseLeave: (event: React.MouseEvent) => void;
  dropdownRef: React.RefObject<HTMLDivElement>;
};
const BreadcrumbDropdown = ({
  activeDropdown,
  leftPosition,
  onMouseLeave,
  dropdownRef
}: DropdownProps): JSX.Element => <nav role="listbox" aria-label="Breadcrumb dropdown" ref={dropdownRef} onMouseLeave={onMouseLeave} sx={{
  ...styles.breadcrumbDropdown(activeDropdown !== null),
  left: `${leftPosition}px`
}}>
    {activeDropdown && <>
        {activeDropdown.href ? <div sx={styles.dropdownItemActive}>
            <Link href={activeDropdown.href} sx={styles.dropdownItemLink}>
              {activeDropdown.name}
            </Link>
          </div> : <div sx={styles.dropdownItemActive}>{activeDropdown.name}</div>}
        {activeDropdown.siblings?.map(sibling => sibling.href && <div sx={styles.dropdownItem} key={`sibling-${activeDropdown.id}-${sibling.id}`}>
                <Link href={sibling.href} sx={styles.dropdownItemLink}>
                  {sibling.name}
                </Link>
              </div>)}
      </>}
  </nav>;
export default BreadcrumbDropdown;